import { useEffect } from 'react';
import { useAuth } from '@/shared/hooks';
import { useAppDispatch } from './hooks';
import { setAuthUserId, clearAuth } from './slices/authSlice';

/**
 * AuthReduxSync - Bridges React Context auth to Redux
 *
 * This component syncs the authenticated user's ID from AuthContext
 * to Redux, making it available to middleware and reducers globally.
 *
 * Place this inside both AuthProvider and Redux Provider.
 */
export function AuthReduxSync({ children }: { children: React.ReactNode }) {
  const { appUser } = useAuth();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (appUser?.id) {
      dispatch(setAuthUserId(appUser.id));
    } else {
      dispatch(clearAuth());
    }
  }, [appUser?.id, dispatch]);

  return <>{children}</>;
}
